import React, { useEffect, useState } from "react";
import ExchangeForm from "../../components/Exchange/ExchangeForm/ExchangeForm";
import VerificationBanner from "../../components/Exchange/VerificationBanner";
import { userAPI, authAPI, alertAPI, ALERT_EVENTS } from "../../services/api";
import { useTelegram } from "../../hooks/useTelegram";
import { useTranslation } from "react-i18next";

const ExchangePage = () => {
  const [activeTab, setActiveTab] = useState("buy");

  const [userInfo, setUserInfo] = useState(null);
  const [isLoadingUser, setIsLoadingUser] = useState(true);
  const { tg } = useTelegram();

  const { t } = useTranslation("exchange")

  useEffect(() => {
    fetchUserInfo();

    if (activeTab === "sell") {
      alertAPI.trigger(ALERT_EVENTS.SELL_VIEW_OPEN);
    }
  }, [activeTab]);

  const fetchUserInfo = async () => {
    try {
      setIsLoadingUser(true);
      const response = await userAPI.getUserInfo();

      if (response.data && response.data.result) {
        setUserInfo(response.data.result);
      } else if (response.data) {
        setUserInfo(response.data);
      }
    } catch (error) {
      console.error('Ошибка получения информации о пользователе:', error);
    } finally {
      setIsLoadingUser(false);
    }
  };

  const handleVerificationClick = async () => {
    try {
      const response = await authAPI.getVerify();

      if (response.data && response.data.redirect_url) {
        // Используем redirect_url для перехода на страницу верификации
        if (tg) {
          tg.openLink(response.data.redirect_url)
        } else {
          window.open(response.data.redirect_url, '_blank');
        }
      } else if (response.data && response.data.iframe_url) {
        // Если redirect_url нет, используем iframe_url
        if (tg) {
          tg.openLink(response.data.iframe_url)
        } else {
          window.open(response.data.iframe_url, '_blank');
        }
      } else {
        console.error('Не получена ссылка для верификации');
      }
    } catch (error) {
      console.error('Ошибка получения ссылки верификации:', error);
      // В случае ошибки можно показать уведомление пользователю
    }
  };

  return (
    <div className="w-full max-w-2xl mx-auto px-4">
      {/* Tabs */}
      <div className="flex bg-white rounded-xl mb-6 overflow-hidden shadow-md">
        <button
          className={`flex-1 py-4 text-base font-medium transition 
            ${activeTab === "buy"
              ? "bg-blue-500 text-white"
              : "bg-white text-gray-600 hover:bg-gray-50"
            }`}
          onClick={() => setActiveTab("buy")}
        >
          {t("BUY")}
        </button>
        <button
          className={`flex-1 py-4 text-base font-medium transition 
            ${activeTab === "sell"
              ? "bg-blue-500 text-white"
              : "bg-white text-gray-600 hover:bg-gray-50"
            }`}
          onClick={() => setActiveTab("sell")}
        >
          {t("SELL")}
        </button>
      </div>

      {/* Баннер верификации - под табами */}
      {!isLoadingUser && userInfo && (
        <VerificationBanner
          userStatus={userInfo.status}
          onVerifyClick={handleVerificationClick}
        />
      )}

      {/* Form */}
      <ExchangeForm activeTab={activeTab} />
    </div>
  );
};

export default ExchangePage;